import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
  useLocation,
} from "react-router-dom";
import NotFound from "./Components/NotFound";
import MainLayout from "./Layout/MainLayout";
import CompanyForm from "./Pages/CompanyForm";
import Dashboard from "./Pages/Dashboard";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import StudentForm from "./Pages/StudentForm";
import Test from "./Pages/Test";

import { engApi } from "./api/engApi";
import { useDispatch, useSelector } from "react-redux";
import { updateIsMember, updateProfile } from "./redux/action/profileAction";
import Profile from "./Pages/Profile";
import CompanyDetail from "./Pages/CompanyDetail";
import Company from "./Pages/Company";
import Task from "./Pages/administrator/Task";
import CompanyReview from "./Pages/administrator/CompanyReview";
import Approval from "./Pages/administrator/Approval";
import DocumentRequest from "./Pages/DocumentRequest";
import InternshipAnswer from "./Pages/administrator/InternshipAnswer";
import DrawerLayout from "./Layout/DrawerLayout";

import { MessengerChat } from "react-messenger-chat-plugin";

import DashboardCompany from "./Pages/DashboardCompany";
import InternForm from "./Pages/InternForm";
import StudentManagement from "./Pages/administrator/StudentManagement";
import JobRequest from "./Pages/JobRequest";
import EventDetail from "./Pages/EventDetail";
import Event from "./Pages/Event";
import PDFPreviewDemo from "./Components/PDFPreviewDemo";
import PDFAnalysisDemo from "./Components/PDFAnalysisDemo";

import ActivityLog from "./Pages/ActivityLog";
import EventById from "./Pages/EventById";
import { Alert, Snackbar } from "@mui/material";
import { updateSnackbar } from "./redux/action/dataAction";
import Manual from "./Pages/Manual";
import InternManual from "./Pages/InternManual";
import DashboardInternship from "./Pages/DashboardInternship";
import DashboardEvalution from "./Pages/DashboardEvalution";
import DashboardEvalutionCoop from "./Pages/DashboardEvalutionCoop";
import Staff from "./Pages/Staff";
import AssessmentVisit from "./Pages/AssessmentVisit";
import AssessmentPresent from "./Pages/AssessmentPresent";
import AssessmentVisitCoop from "./Pages/AssessmentVisitCoop";
import AssessmentPresentCoop from "./Pages/AssessmentPresentCoop";
import InternshipEvaluation from "./Pages/InternshipEvaluation";
import CoopEvaluationDisplay from "./Pages/CoopEvaluationDisplay";
import SupervisorEvaluationVisualization from "./Pages/SupervisorEvaluationVisualization";
import CoopReportVisualization from "./Pages/CoopReportVisualization";
import FacultyDashboard from "./Pages/FacultyDashboard";
import AdminSettings from "./Pages/administrator/AdminSettings";
import StudentEvaluation from "./Pages/StudentEvaluation";
import AIAnalysisReport from "./Pages/AIAnalysisReport";


const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getUsername = localStorage.getItem("username");
  // const getUsername = 55050419;
  const profile = useSelector((state) => state.profileReducer.profile);
  const snackbar = useSelector((state) => state.dataReducer.snackbar);

  const getStudentDetail = async () => {
    try {
      const response = await engApi.get("/all-student/");

      const user = response.data.find((st) => st.id == getUsername);
      dispatch(updateProfile(user));

      const resMember = await engApi.get("/intern-student/");

      const isMember = resMember.data.find((el) => el.id == getUsername);

      if (user && isMember) {
        // navigate("/");
        // dispatch(updateIsMember(true));
      } else if (user && !isMember) {
        const resMember2 = await engApi.get("/intern-student2/");
        const isMember = await resMember2.data?.find(
          (el) => el.id == getUsername
        );
        if (!isMember) {
          navigate("/student-form");
        } // dispatch(updateIsMember(false));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getStaffDetail = async () => {
    try {
      const response = await engApi.get("/all-staff/");

      const user = response.data.find((st) => st.id == getUsername);

      dispatch(updateProfile(user));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isNaN(getUsername)) {
      getStaffDetail();
    } else {
      getStudentDetail();
    }
  }, []);

  const ProtectedRoute = ({ profile, redirectPath = "/" }) => {
    if (
      (profile && profile.m_role == "staff") ||
      window.location.hostname == "localhost"
    ) {
      return <Outlet />;
    }

    return <Navigate to={redirectPath} replace />;
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch(
      updateSnackbar({
        open: false,
        content: "",
      })
    );
  };

  return (
    <>
      <MessengerChat pageId="291328901489840" />

      <Routes>
        <Route path="/" element={<DrawerLayout />}>
          <Route element={<ProtectedRoute profile={profile} />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard-company" element={<DashboardCompany />} />
            <Route path="/dashboard-internship" element={<DashboardInternship />} />
            <Route path="/dashboard-evaulation" element={<DashboardEvalution />} />
            <Route path="/dashboard-evaulationcoop" element={<DashboardEvalutionCoop />} />
            <Route path="/faculty-dashboard" element={<FacultyDashboard />} />

            <Route path="/task" element={<Task />} />
            <Route path="/approval" element={<Approval />} />
            <Route path="/internship-answer" element={<InternshipAnswer />} />
            <Route path="/student-manage" element={<StudentManagement />} />
            <Route path="/assessment-visit" element={<AssessmentVisit />} />
            <Route path="/assessment-visitcoop" element={<AssessmentVisitCoop />} />
            <Route path="/assessment-report" element={<AssessmentPresent />} />
            <Route path="/assessment-presentcoop" element={<AssessmentPresentCoop />} />
            <Route path="/internship-evaluation" element={<InternshipEvaluation />} />
            <Route path="/coop-evaluation" element={<CoopEvaluationDisplay />} />
            <Route path="/supervisor-evaluation" element={<SupervisorEvaluationVisualization />} />
            <Route path="/student-evaluation" element={<StudentEvaluation />} />
            <Route path="/ai-analysis-report" element={<AIAnalysisReport />} />
            <Route path="/admin-settings" element={<AdminSettings />} />

          </Route>

          <Route path="/intern-manual" element={<InternManual />} />
          <Route index element={<Home />} />
          <Route path="/manual" element={<Manual />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/student-form" element={<StudentForm />} />
          <Route path="/request-form" element={<CompanyForm />} />
          <Route path="/job-request" element={<JobRequest />} />
          <Route path="/company-detail" element={<CompanyDetail />} />
          <Route path="/profile" element={<Profile />} />

          <Route path="/company-review" element={<CompanyReview />} />
          <Route path="/company/:id" element={<Company />} />
          <Route path="/pdf-preview-demo" element={<PDFPreviewDemo />} />
          <Route path="/pdf-analysis-demo" element={<PDFAnalysisDemo />} />
          <Route path="/event" element={<Event />} />
          <Route path="/event-detail" element={<EventById />} />

          <Route path="/activity-log" element={<ActivityLog />} />
          <Route path="/coop-report-evaluation" element={<CoopReportVisualization />} />

          {/* <Route path="/event-details" element={<EventDetail />} /> */}
          {/* <Route path="/event-details/:id" element={<EventDetail />} /> */}
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/document-request" element={<DocumentRequest />} />
        <Route path="/intern-form" element={<InternForm />} />

        <Route path="/login" element={<Login />} />
        <Route path="/test" element={<Test />} />
      </Routes>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar?.open || false}
        onClose={handleCloseSnack}
        autoHideDuration={2000}
      >
        <Alert
          onClose={handleCloseSnack}
          severity={snackbar?.severity ?? "success"}
          sx={{ width: "100%" }}
        >
          {snackbar?.content || ""}
        </Alert>
      </Snackbar>
    </>
  );
};

export default App;
